import { render } from "./LoaderButton.vue?vue&type=template&id=36cca69e&scoped=true&ts=true"
import script from "./LoaderButton.vue?vue&type=script&lang=ts"
export * from "./LoaderButton.vue?vue&type=script&lang=ts"

import "./LoaderButton.vue?vue&type=style&index=0&id=36cca69e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cca69e"]])

export default __exports__